import { render, staticRenderFns } from "./OrderMetadataItem.vue?vue&type=template&id=587f1c6c&scoped=true&"
import script from "./OrderMetadataItem.vue?vue&type=script&lang=ts&"
export * from "./OrderMetadataItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMetadataItem.vue?vue&type=style&index=0&id=587f1c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f1c6c",
  null
  
)

export default component.exports